export const statementsStructure = [
    {
      id: "A",
      header: "Professionalism",
      subheaders: [
        {
          id: "A1",
          subheader: "Etisk kompetens",
          questions: ["A1.1", "A1.2", "A1.3", "A1.4"],
        },
        {
          id: "A2",
          subheader: "Teori- och forskningsbaserad kompetens",
          questions: ["A2.1", "A2.2", "A2.3"],
        },
        {
          id: "A3",
          subheader: "Reflekterande kompetens",
          questions: ["A3.1", "A3.2"],
        },
        {
          id: "A4",
          subheader: "Kommunikations- och interaktionskompetens",
          questions: ["A4.1", "A4.2", "A4.3", "A4.4"],
        },
        {
          id: "A5",
          subheader: "Digital kompetens",
          questions: ["A5.1", "A5.2", "A5.3", "A5.4", "A5.5"],
        },
      ],
    },
    {
      id: "B",
      header: "Kompetens inom kundarbete",
      subheaders: [
        {
          id: "B1",
          subheader: "Processkompetens",
          questions: ["B1.1", "B1.2", "B1.3"],
        },
        {
          id: "B2",
          subheader: "Kompetens om väglednings- och lärandeteorier",
          questions: ["B2.1", "B2.2", "B2.3", "B2.4", "B2.5", "B2.6"],
        },
        {
          id: "B3",
          subheader: "Metodologisk kompetens",
          questions: ["B3.1", "B3.2", "B3.3", "B3.4"],
        },
      ],
    },
    {
      id: "C",
      header: "Systemisk kompetens",
      subheaders: [
        {
          id: "C1",
          subheader: "Livslång vägledning",
          questions: ["C1.1", "C1.2", "C1.3"],
        },
        {
          id: "C2",
          subheader: "Systemteoretisk kompetens",
          questions: ["C2.1", "C2.2"],
        },
        {
          id: "C3",
          subheader: "Nätverkskompetens",
          questions: ["C3.1", "C3.2"],
        },
        {
          id: "C4",
          subheader: "Strategisk kompetens",
          questions: ["C4.1", "C4.2", "C4.3"],
        },
      ],
    },
  ];